import React from "react";
import styled from "styled-components";
import { Control } from "react-hook-form";
import InputField from "components/UI/InputField/InputField";
import UserTypeSelect from "components/common/user/UserTypeSelect/UserTypeSelect";
import SubmitResetNav from "components/common/form/SubmitResetNav";
import FormFieldContainer from "components/layout/style/form/FormFieldContainer";

export type UserFormState = {
  un: string;
  email: string;
  firstName: string;
  lastName: string;
  uType: string;
  pw: string;
  pwRepeat: string;
};

type UserFormProps = {
  control: Control<UserFormState>;
  errorText?: string;
  isEditMode?: boolean;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onReset: () => void;
};

const UserForm = ({
  control,
  errorText = "",
  isEditMode = false,
  onSubmit,
  onReset,
}: UserFormProps) => {
  return (
    <DivForm>
      <form onSubmit={onSubmit}>
        <SubmitResetNav onReset={onReset} />
        <FormFieldContainer>
          <InputField name="un" control={control} label="Korisnicko ime" id="un" />
        </FormFieldContainer>
        <FormFieldContainer>
          <InputField name="email" control={control} label="Email" id="email" />
        </FormFieldContainer>
        <FormFieldContainer>
          <InputField name="firstName" control={control} label="Ime" id="firstName" />
        </FormFieldContainer>
        <FormFieldContainer>
          <InputField name="lastName" control={control} label="Prezime" id="lastName" />
        </FormFieldContainer>
        <FormFieldContainer>
          <UserTypeSelect<UserFormState> control={control} />
        </FormFieldContainer>
        <FormFieldContainer>
          <InputField
            name="pw"
            control={control}
            label={`Lozinka ${isEditMode ? "(ostavi prazno ako se ne menja)" : ""}`}
            id="pw"
            type="password"
          />
        </FormFieldContainer>
        <FormFieldContainer>
          <InputField name="pwRepeat" control={control} label="Ponovljena lozinka" id="pwRepeat" type="password" />
        </FormFieldContainer>
        {errorText !== "" && <ErrorText>{errorText}</ErrorText>}
        <DivNav>
          <SubmitResetNav onReset={onReset} />
        </DivNav>
      </form>
    </DivForm>
  );
};

const DivForm = styled.div`
  margin-top: 0.75rem;
`;

const DivNav = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
`;

const ErrorText = styled.div`
  margin-top: 0.5rem;
  color: #b00020;
  font-weight: 600;
`;

export default UserForm;
